// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TaxlistTemplate_taxlistTemplatemain__J3o9G {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 16px;
  border: 1px solid #EEF0F6;
  border-radius: 14px;
  margin: 0 0 12px;
  background: #ffffff;
  transition: box-shadow 0.15s ease;
}
.TaxlistTemplate_taxlistTemplatemain__J3o9G:hover {
  box-shadow: 0 8px 22px rgba(43, 22, 87, 0.08);
}

.TaxlistTemplate_taxlistTemplateImage__r4Bih {
  flex-shrink: 0;
}

.TaxlistTemplate_taxlistTemplateImage__r4Bih span {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 10px;
  background: #F5F3FE;
  color: #4c2fb3;
  font-weight: 700;
  font-size: 12.5px;
}

.TaxlistTemplate_taxlistTemplateDesc__gke5m {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.TaxlistTemplate_taxlistTemplateDesc__gke5m p {
  margin: 0;
  font-size: 13px;
  color: #6B7280;
  font-weight: 500;
  line-height: 1.5;
  text-transform: none;
}

.TaxlistTemplate_taxlistTemplateDesc__gke5m p span:first-child {
  color: #6B7280;
  font-weight: 600;
  margin-right: 4px;
}

.TaxlistTemplate_taxlistTemplateDesc__gke5m p span:last-child {
  color: #1F2430;
  font-weight: 700;
}

.TaxlistTemplate_success__1AodN,
.TaxlistTemplate_danger__JawKo {
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  border: none;
  outline: none;
  padding: 3px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
  cursor: default;
}
.TaxlistTemplate_success__1AodN {
  background: #E9F9EF !important;
  color: #16A34A !important;
}
.TaxlistTemplate_danger__JawKo {
  background: #FDEDED !important;
  color: #DC2626 !important;
}

.TaxlistTemplate_taxlistTemplateedit__iI5lk {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 6px;
}

.TaxlistTemplate_iconBtn__Flexw {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background: #F5F3FE;
  cursor: pointer;
  transition: background 0.15s ease;
  border: none;
}
.TaxlistTemplate_iconBtn__Flexw:hover {
  background: #E7DEFB;
}

.TaxlistTemplate_taxlistTemplateedit__iI5lk img {
  width: 18px;
  height: 18px;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/TaxlistTemplate/TaxlistTemplate.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,iCAAiC;AACnC;AACA;EACE,6CAA6C;AAC/C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;AACA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iCAAiC;EACjC,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB","sourcesContent":[".taxlistTemplatemain {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n  padding: 16px;\n  border: 1px solid #EEF0F6;\n  border-radius: 14px;\n  margin: 0 0 12px;\n  background: #ffffff;\n  transition: box-shadow 0.15s ease;\n}\n.taxlistTemplatemain:hover {\n  box-shadow: 0 8px 22px rgba(43, 22, 87, 0.08);\n}\n\n.taxlistTemplateImage {\n  flex-shrink: 0;\n}\n\n.taxlistTemplateImage span {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  height: 34px;\n  border-radius: 10px;\n  background: #F5F3FE;\n  color: #4c2fb3;\n  font-weight: 700;\n  font-size: 12.5px;\n}\n\n.taxlistTemplateDesc {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.taxlistTemplateDesc p {\n  margin: 0;\n  font-size: 13px;\n  color: #6B7280;\n  font-weight: 500;\n  line-height: 1.5;\n  text-transform: none;\n}\n\n.taxlistTemplateDesc p span:first-child {\n  color: #6B7280;\n  font-weight: 600;\n  margin-right: 4px;\n}\n\n.taxlistTemplateDesc p span:last-child {\n  color: #1F2430;\n  font-weight: 700;\n}\n\n.success,\n.danger {\n  display: inline-flex;\n  align-items: center;\n  align-self: flex-start;\n  border: none;\n  outline: none;\n  padding: 3px 12px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 700;\n  cursor: default;\n}\n.success {\n  background: #E9F9EF !important;\n  color: #16A34A !important;\n}\n.danger {\n  background: #FDEDED !important;\n  color: #DC2626 !important;\n}\n\n.taxlistTemplateedit {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.iconBtn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  border-radius: 8px;\n  background: #F5F3FE;\n  cursor: pointer;\n  transition: background 0.15s ease;\n  border: none;\n}\n.iconBtn:hover {\n  background: #E7DEFB;\n}\n\n.taxlistTemplateedit img {\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"taxlistTemplatemain": `TaxlistTemplate_taxlistTemplatemain__J3o9G`,
	"taxlistTemplateImage": `TaxlistTemplate_taxlistTemplateImage__r4Bih`,
	"taxlistTemplateDesc": `TaxlistTemplate_taxlistTemplateDesc__gke5m`,
	"success": `TaxlistTemplate_success__1AodN`,
	"danger": `TaxlistTemplate_danger__JawKo`,
	"taxlistTemplateedit": `TaxlistTemplate_taxlistTemplateedit__iI5lk`,
	"iconBtn": `TaxlistTemplate_iconBtn__Flexw`
};
export default ___CSS_LOADER_EXPORT___;
